import React from 'react';

import AllComplaint from './allComplaint';

import './styles.css';
import SearchManual from '../../components/Search/SearchManual';
import { useLateNotification } from '../../hooks';
import SearchProvider from '../../contexts/SearchContext';

export default function Search() {
  useLateNotification();

  return (
    <SearchProvider>
      <AllComplaint />
      <SearchManual />
    </SearchProvider>
  );
}


